import { useEffect, useState } from "react";

export const WindowSize = {
  SMALL: "SMALL",
  LARGE: "LARGE",
};

export type WindowSizeType = typeof WindowSize.SMALL | typeof WindowSize.LARGE;

// Returns "sm" or "lg" depending on the window's current width. The default
// cutoff for "lg" is 1024px, the same as Tailwind's default.
export default function useWindowSize(
  wCutoff: number = 1024,
  hCutoff: number = 750,
) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    windowWidth: windowWidth >= wCutoff ? WindowSize.LARGE : WindowSize.SMALL,
    windowHeight: windowHeight >= hCutoff ? WindowSize.LARGE : WindowSize.SMALL,
  };
}
